/* 3NODE — Doporučení trhu a jazyka podle IP (Freelo 32408831).
   Popis chování a pořadí rozhodování: snippets/rf-market-suggest.liquid. */
(function () {
  'use strict';

  var configEl = document.getElementById('rf-ms-config');
  if (!configEl) return;
  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var params = new URLSearchParams(window.location.search);
  var testCountry = (params.get('rf_loc_test') || '').toUpperCase();
  var testLang = (params.get('rf_loc_lang') || '').toLowerCase();
  var testStyle = (params.get('rf_loc_style') || '').toLowerCase();
  var testing = testCountry !== '';
  var welcomeTest = params.get('rf_welcome_test') === '1';

  // Vypnuté nastavení nebo editor motivu: běží jen s testovacím parametrem.
  if (!testing && (!cfg.enabled || cfg.designMode)) return;
  if (!testing && (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent))) return;

  var CHOICE_KEY = 'rf-loc-choice';
  var SHOWN_KEY = 'rf-loc-shown';
  var WELCOME_KEY = 'rf-loc-welcome';
  var COUNTRY_KEY = 'rf-loc-country';
  // Zvolená verze webu (předpona URL) a příznaky pro snippet rf-loc-redirect.
  // Klíče musí sedět s tím snippetem — čte je dřív, než se načte tenhle skript.
  var PREF_KEY = 'rf-loc-pref';
  var PENDING_KEY = 'rf-loc-pending';
  var STAY_KEY = 'rf-loc-stay';
  // Odmítnuté znovunabídnutí: zticha na měsíc, ať z nabídky není otrava.
  var NAG_KEY = 'rf-loc-nag';
  var NAG_DAYS = 30;
  var DAY = 864e5;
  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function storage(session) {
    try {
      return session ? window.sessionStorage : window.localStorage;
    } catch (e) {
      return null;
    }
  }
  function read(key, session) {
    var s = storage(session);
    try {
      return s ? s.getItem(key) : null;
    } catch (e) {
      return null;
    }
  }
  function write(key, value, session) {
    var s = storage(session);
    try {
      if (s) s.setItem(key, value);
    } catch (e) {
      /* soukromý režim apod. — volba se jen nezapamatuje */
    }
  }

  function hasChoice() {
    var raw = read(CHOICE_KEY);
    if (!raw) return false;
    try {
      return Date.now() - JSON.parse(raw).t < (Number(cfg.days) || 180) * DAY;
    } catch (e) {
      return false;
    }
  }
  // Předpona verze webu v jednotném tvaru: '/' pro kořen, jinak '/cs-cz'.
  function normPrefix(value) {
    var path = String(value == null ? '/' : value).replace(/\/+$/, '');
    return path === '' ? '/' : path;
  }
  var CURRENT_PREFIX = normPrefix(cfg.root);

  function saveChoice(kind) {
    write(CHOICE_KEY, JSON.stringify({ t: Date.now(), kind: kind }));
    // Volba verze se dokončí až po reloadu — formulář lokalizace odesílá
    // stránku a cílovou předponu určí Shopify, ne my. Proto se tu jen
    // poznamená záměr a zapíše se po příchodu na novou verzi.
    if (kind === 'selector' || kind === 'accept') write(PENDING_KEY, '1', true);
    if (kind === 'stay') write(STAY_KEY, '1', true);
  }

  // Doběh volby z předchozí stránky: teď už víme, kde zákazník skončil.
  if (read(PENDING_KEY, true)) {
    var pendingStore = storage(true);
    try {
      if (pendingStore) pendingStore.removeItem(PENDING_KEY);
    } catch (e) {
      /* soukromý režim — jen se nevyčistí */
    }
    write(PREF_KEY, JSON.stringify({ t: Date.now(), prefix: CURRENT_PREFIX }));
  }

  // Ruční volba v přepínači v hlavičce se počítá jako uložená volba.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var form = target.closest('form');
      if (form && form.id !== 'RfMarketSuggestForm' && form.querySelector('[name="country_code"], [name="language_code"]')) {
        if (target.closest('button, a, [role="option"], .localization-form__list-item')) saveChoice('selector');
      }
    },
    true
  );
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (target && (target.name === 'language_code' || target.name === 'country_code')) {
        var form = target.closest && target.closest('form');
        if (form && form.id !== 'RfMarketSuggestForm') saveChoice('selector');
      }
    },
    true
  );

  // Uvítací okno se ukáže jednou za návštěvníka i tomu, kdo si už zemi
  // zvolil — oznamuje novou adresu, ne jen trh.
  var welcomePending =
    welcomeTest || (cfg.welcome && cfg.welcome.enabled && !cfg.designMode && !read(WELCOME_KEY));

  // Znovunabídnutí (Freelo 32760704): zákazník volbu má, ale je na verzi,
  // která neodpovídá jeho zemi. Dřív jsme v takovém případě 180 dní mlčeli,
  // takže kdo si jednou zvolil špatně, nabídku už nikdy neuviděl. Teď se
  // nabídka vrací — ale jako proužek, jednou za relaci a po odmítnutí měsíc
  // vůbec. Automatické přesměrování mimo EU se na ně nevztahuje: zvolenou
  // verzi zákazníka nepřebíjíme.
  function nagBlocked() {
    var raw = read(NAG_KEY);
    if (!raw) return false;
    try {
      return Date.now() - JSON.parse(raw).t < NAG_DAYS * DAY;
    } catch (e) {
      return false;
    }
  }
  var reoffer = !welcomePending && hasChoice() && !nagBlocked();

  if (!testing && !welcomePending && hasChoice() && !reoffer) return;
  if (!testing && !welcomePending && read(SHOWN_KEY, true)) return;

  function browserLangs() {
    if (testLang) return [testLang];
    var list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var code = String(list[i]).toLowerCase().split('-')[0];
      if (code && out.indexOf(code) === -1) out.push(code);
    }
    return out;
  }

  // Jazyk pro přechod na jiný trh: viz languageFor, jinak angličtina.
  function pickLang(langs, country) {
    var found = languageFor(langs, country);
    if (found) return found;
    if (langs.indexOf('en') !== -1) return 'en';
    return langs[0] || cfg.locale;
  }

  // Jazyk textu panelu: zvolený jazyk, pokud pro něj máme texty, jinak angličtina.
  function textLang(lang) {
    return cfg.texts.note[lang] ? lang : 'en';
  }

  function countryName(code, lang, fallback) {
    try {
      return new Intl.DisplayNames([lang], { type: 'region' }).of(code) || fallback;
    } catch (e) {
      return fallback;
    }
  }

  function fill(template, values) {
    return String(template).replace(/\{(\w+)\}/g, function (m, key) {
      return values[key] != null ? values[key] : m;
    });
  }

  function detectCountry() {
    if (testing) return Promise.resolve(testCountry);
    var cached = read(COUNTRY_KEY, true);
    if (cached) return Promise.resolve(cached);
    return fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var code = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (code) write(COUNTRY_KEY, code, true);
        return code || null;
      })
      .catch(function () {
        return null;
      });
  }

  function submitLocalization(country, lang) {
    var form = document.getElementById('RfMarketSuggestForm');
    if (!form) return;
    form.querySelector('[name="country_code"]').value = country;
    form.querySelector('[name="language_code"]').value = lang;
    form.submit();
  }

  var CLOSE_ICON =
    '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">' +
    '<path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function showPanel(opts) {
    // Znovunabídnutí je vždy proužek — kdo už volbu má, nemá dostat okno přes celý web.
    var asModal = !reoffer && (testStyle || cfg.style) === 'modal';

    var panel = el('div', 'rf-ms' + (asModal ? ' rf-ms--modal' : ''));
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', asModal ? 'true' : 'false');
    panel.setAttribute('aria-labelledby', 'rf-ms-title');
    panel.setAttribute('lang', opts.lang);

    var head = el('div', 'rf-ms__head');
    var title = el('p', 'rf-ms__title', opts.title);
    title.id = 'rf-ms-title';
    var close = el('button', 'rf-ms__close');
    close.type = 'button';
    close.setAttribute('aria-label', cfg.texts.close[opts.lang] || cfg.texts.close.en);
    close.innerHTML = CLOSE_ICON;
    head.appendChild(title);
    head.appendChild(close);
    panel.appendChild(head);

    /* Bez popisku, když ho volající nepošle — návrh WelcomeModalu (Martin
       23. 9.): „Dává nám větší smysl pracovat pouze s úderným headlinem." */
    if (opts.body) panel.appendChild(el('p', 'rf-ms__body', opts.body));

    var cta = el('button', 'rf-btn rf-btn--primary rf-ms__cta', opts.cta);
    cta.type = 'button';
    panel.appendChild(cta);

    var stay = el('button', 'rf-ms__stay', opts.stay);
    stay.type = 'button';
    panel.appendChild(stay);

    panel.appendChild(el('p', 'rf-ms__note', cfg.texts.note[opts.lang] || cfg.texts.note.en));

    var overlay = null;
    var lastFocused = document.activeElement;

    if (asModal) {
      overlay = el('div', 'rf-ms-overlay');
      overlay.addEventListener('click', function () {
        dismiss();
      });
      document.body.appendChild(overlay);
      document.body.classList.add('rf-ms-lock');
    }

    function cleanup() {
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.removeEventListener('keydown', onKey, true);
      document.body.classList.remove('rf-ms-lock');
      window.setTimeout(function () {
        if (panel.parentNode) panel.parentNode.removeChild(panel);
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 250);
      if (asModal && lastFocused && lastFocused.focus) {
        try {
          lastFocused.focus();
        } catch (e) {
          /* prvek mezitím zmizel */
        }
      }
    }

    function dismiss() {
      saveChoice('stay');
      if (reoffer) write(NAG_KEY, JSON.stringify({ t: Date.now() }));
      cleanup();
    }

    function onKey(event) {
      if (event.key === 'Escape') {
        dismiss();
        return;
      }
      // V okně drží fokus uvnitř, aby se za ztmavením nedalo tabovat po webu.
      if (asModal && event.key === 'Tab') {
        var items = panel.querySelectorAll(FOCUSABLE);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        } else if (!panel.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    cta.addEventListener('click', function () {
      saveChoice('accept');
      opts.onAccept();
    });
    stay.addEventListener('click', dismiss);
    close.addEventListener('click', dismiss);
    document.addEventListener('keydown', onKey, true);

    document.body.appendChild(panel);
    write(SHOWN_KEY, '1', true);

    function open() {
      if (panel.classList.contains('is-open')) return;
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      if (asModal) {
        try {
          cta.focus({ preventScroll: true });
        } catch (e) {
          cta.focus();
        }
      }
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(open);
    });
    // Pojistka: rAF se na skryté kartě nebo při změně velikosti okna nemusí
    // spustit a panel by zůstal průhledný mimo obrazovku.
    window.setTimeout(open, 300);
  }


  /* ---------------------------------------------------------------
     Uvítací okno (Figma WelcomeModal). Jednou za návštěvníka: nová
     adresa a branding + výběr země a jazyka. Texty podle země z IP
     (Čech česky, zbytek anglicky) — proto nejsou v locales, ale
     v konfiguraci ve snippetu.
     --------------------------------------------------------------- */
  function welcomeTexts(country) {
    var all = (cfg.welcome && cfg.welcome.texts) || {};
    var lang = country === 'CZ' ? 'cs' : 'en';
    return { lang: lang, t: all[lang] || all.en };
  }

  function countryOptions(selected, lang) {
    var select = el('select', 'rf-wel__select');
    var codes = Object.keys(cfg.countries);
    codes
      .map(function (code) {
        return { code: code, name: countryName(code, lang, cfg.countries[code][3]) };
      })
      .sort(function (a, b) {
        return a.name.localeCompare(b.name, lang);
      })
      .forEach(function (item) {
        var option = el('option', null, item.name);
        option.value = item.code;
        if (item.code === selected) option.selected = true;
        select.appendChild(option);
      });
    return select;
  }

  function languageOptions(select, code) {
    var entry = cfg.countries[code] || [];
    var langs = entry[2] && entry[2].length ? entry[2] : cfg.languages || [];
    var names = (cfg.welcome && cfg.welcome.langNames) || {};
    select.textContent = '';
    langs.forEach(function (iso) {
      var option = el('option', null, names[iso] || iso.toUpperCase());
      option.value = iso;
      select.appendChild(option);
    });
    var preferred = languageFor(langs, code) || (langs.indexOf(cfg.locale) !== -1 ? cfg.locale : langs[0]);
    if (preferred) select.value = preferred;
  }

  function showWelcome(country, entry) {
    var pack = welcomeTexts(country);
    var texts = pack.t;
    if (!texts) return;
    var lang = pack.lang;

    write(WELCOME_KEY, String(Date.now()));

    var overlay = el('div', 'rf-ms-overlay rf-wel-overlay');
    var card = el('div', 'rf-wel');
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');
    card.setAttribute('aria-labelledby', 'rf-wel-title');
    card.setAttribute('lang', lang);

    var close = el('button', 'rf-wel__close');
    close.type = 'button';
    close.setAttribute('aria-label', cfg.texts.close[lang] || cfg.texts.close.en);
    close.innerHTML = CLOSE_ICON;
    card.appendChild(close);

    var head = el('div', 'rf-wel__head');
    var title = el('p', 'rf-wel__title');
    title.id = 'rf-wel-title';
    (texts.title || []).forEach(function (line, index) {
      var span = el('span', index === 2 ? 'rf-wel__title-line rf-wel__title-line--accent' : 'rf-wel__title-line', line);
      title.appendChild(span);
    });
    head.appendChild(title);

    if (cfg.welcome && cfg.welcome.image) {
      var img = el('img', 'rf-wel__image');
      img.src = cfg.welcome.image;
      img.alt = texts.imageAlt || '';
      head.appendChild(img);

      /* Adresy pod logy jsou text, ne součást obrázku — v <img> by SVG
         nedosáhlo na písmo webu a vysadilo by je patkovým fallbackem. */
      var domains = (cfg.welcome && cfg.welcome.domains) || [];
      if (domains.length === 2) {
        var row = el('div', 'rf-wel__domains');
        row.appendChild(el('span', 'rf-wel__domain rf-wel__domain--old', domains[0]));
        row.appendChild(el('span', 'rf-wel__domain rf-wel__domain--new', domains[1]));
        head.appendChild(row);
      }
    }
    card.appendChild(head);

    var body = el('div', 'rf-wel__body');

    /* Nabídka zjištěné země. Bez známé země (blokované zjišťování) zbyde
       jen výběr níž. */
    if (country && entry) {
      var name = countryName(country, lang, entry[3]);
      var isCz = country === 'CZ';
      body.appendChild(
        el('p', 'rf-wel__country', fill(isCz ? texts.country : texts.countryOther, { country: name }))
      );
      var cta = el('button', 'rf-btn rf-btn--brand rf-wel__cta', fill(isCz ? texts.cta : texts.ctaOther, { country: name }));
      cta.type = 'button';
      cta.addEventListener('click', function () {
        saveChoice('welcome');
        submitLocalization(country, pickLang(entry[2] || [], country));
      });
      body.appendChild(cta);
      body.appendChild(el('p', 'rf-wel__or', texts.or));
    }

    var picker = el('div', 'rf-wel__picker');

    var countryField = el('div', 'rf-wel__field');
    countryField.appendChild(el('span', 'rf-wel__label', texts.countryLabel));
    var countrySelect = countryOptions(country && cfg.countries[country] ? country : cfg.country, lang);
    countryField.appendChild(countrySelect);
    picker.appendChild(countryField);

    var langField = el('div', 'rf-wel__field');
    langField.appendChild(el('span', 'rf-wel__label', texts.languageLabel));
    var langSelect = el('select', 'rf-wel__select');
    languageOptions(langSelect, countrySelect.value);
    langField.appendChild(langSelect);
    picker.appendChild(langField);

    countrySelect.addEventListener('change', function () {
      languageOptions(langSelect, countrySelect.value);
    });

    var submit = el('button', 'rf-wel__submit', texts.submit);
    submit.type = 'button';
    submit.addEventListener('click', function () {
      saveChoice('welcome');
      submitLocalization(countrySelect.value, langSelect.value);
    });
    picker.appendChild(submit);

    body.appendChild(picker);
    card.appendChild(body);

    var lastFocused = document.activeElement;

    function dismiss() {
      saveChoice('stay');
      card.classList.remove('is-open');
      overlay.classList.remove('is-open');
      window.setTimeout(function () {
        if (card.parentNode) card.parentNode.removeChild(card);
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        document.body.classList.remove('rf-ms-lock');
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }, 250);
      document.removeEventListener('keydown', onKey);
    }

    function onKey(event) {
      if (event.key === 'Escape') dismiss();
      if (event.key !== 'Tab') return;
      var items = card.querySelectorAll(FOCUSABLE);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    close.addEventListener('click', dismiss);
    overlay.addEventListener('click', dismiss);
    document.addEventListener('keydown', onKey);

    document.body.appendChild(overlay);
    document.body.appendChild(card);
    document.body.classList.add('rf-ms-lock');

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        card.classList.add('is-open');
        close.focus();
      });
    });
  }

  function suggestMarket(country, entry) {
    var targetMarket = entry[0];
    var currency = entry[1];
    var langs = entry[2] || [];
    var lang = pickLang(langs, country);
    /* Jazyk okna podle země z IP, ne podle toho, kam přepínáme (Oldřich
       23. 9.): „česky Čechům a zbytku světa eng". Němec tak dostane okno
       anglicky, i když ho přepne na německou verzi. */
    var tl = textLang(country === 'CZ' ? 'cs' : 'en');
    var marketTexts = cfg.texts.markets[targetMarket] || {};
    // Panel musí mluvit jazykem, do kterého přepne. Obecný text ve správném
    // jazyce je proto lepší než text trhu v cizím jazyce — jinak vyjde okno
    // anglicky a odkaz „Zůstat…" česky.
    var texts = marketTexts[tl] || cfg.texts.generic[tl] || marketTexts.en || cfg.texts.generic.en;
    var values = { country: countryName(country, tl, entry[3]), currency: currency };
    var stayTexts = cfg.texts.stay[cfg.market] || cfg.texts.stay['*'];

    showPanel({
      lang: tl,
      title: fill(texts.title, values),
      cta: fill(texts.cta, values),
      stay: stayTexts[tl] || cfg.texts.stay['*'][tl] || cfg.texts.stay['*'].en,
      onAccept: function () {
        submitLocalization(country, lang);
      },
    });
  }

  // Jazyk nabídnout jen s důvodem. Pořadí: neanglický jazyk prohlížeče (Čech
  // v Německu → čeština), pak jazyk země (Rakušan s anglickým prohlížečem →
  // němčina), pak angličtina z prohlížeče. Angličtina v prohlížeči je často jen
  // výchozí nastavení, proto má nejnižší váhu. Bez náhradní angličtiny —
  // Francouz na /de nemá dostat nabídku angličtiny.
  function languageFor(langs, country) {
    var browser = browserLangs();
    var i;
    for (i = 0; i < browser.length; i++) {
      if (browser[i] !== 'en' && langs.indexOf(browser[i]) !== -1) return browser[i];
    }
    var preferred = cfg.countryLang[country];
    if (preferred && langs.indexOf(preferred) !== -1) return preferred;
    return langs.indexOf('en') !== -1 && browser.indexOf('en') !== -1 ? 'en' : null;
  }

  function suggestLanguage(country) {
    var lang = languageFor(cfg.languages || [], country);
    if (!lang || lang === cfg.locale) return;
    var texts = cfg.texts.language[lang];
    if (!texts) return;

    showPanel({
      lang: lang,
      title: texts.title,
      /* Bez popisku — stejně jako u nabídky trhu (návrh WelcomeModalu). */
      cta: texts.cta,
      // Odkaz zůstat je taky v nabízeném jazyce: „Weiter auf Englisch".
      stay: (cfg.texts.keepLanguage[lang] || {})[cfg.locale] || cfg.texts.stay['*'][lang] || cfg.texts.stay['*'].en,
      onAccept: function () {
        submitLocalization(country, lang);
      },
    });
  }

  // Zákazník z EU se smí přesměrovat jen se souhlasem (nařízení 2018/302
  // čl. 3 odst. 2) → okno. Mimo EU to nařízení neplatí → rovnou přesměrovat
  // na verzi jeho trhu (USA → /en-us). Ruční volba v hlavičce se pamatuje
  // (hasChoice), takže kdo se vrátí na realfoot.shoes přes výběr, zůstane.
  function mayRedirect(country, entry) {
    return entry[0] !== cfg.market && (cfg.euCountries || []).indexOf(country) === -1;
  }

  function decide(country, entry) {
    if (entry[0] !== cfg.market) {
      suggestMarket(country, entry);
      return;
    }
    // Komu jednou nabídku ukázalo, tomu se připomíná jen jiný TRH. Jazyk si
    // zvolil vědomě (třeba angličtinu na českém trhu) a nemá se přemlouvat.
    if (reoffer) return;
    suggestLanguage(country);
  }

  // Až po cookie liště Shopify, aby se panely nepřekrývaly.
  function afterConsent(callback) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      if (!testing && privacy && typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner()) {
        document.addEventListener(
          'visitorConsentCollected',
          function () {
            window.setTimeout(callback, 400);
          },
          { once: true }
        );
        return;
      }
    } catch (e) {
      /* API nedostupné — pokračovat */
    }
    callback();
  }

  function whenLoaded(callback) {
    if (document.readyState === 'complete') callback();
    else window.addEventListener('load', callback, { once: true });
  }

  // Zemi zjistit hned: přesměrování mimo EU má proběhnout co nejdřív, bez
  // čekání na cookie lištu (souhlas se sem nevztahuje — cookie localization
  // je nezbytná). Okno pro EU až po načtení a po cookie liště.
  detectCountry().then(function (country) {
    var entry = country ? cfg.countries[country] : null;

    // Mimo EU se pořád přesměrovává hned (22. 9.); uvítací okno se ukáže
    // až na verzi jeho trhu, klíč se proto teď nezapisuje.
    if (!reoffer && country && entry && mayRedirect(country, entry)) {
      write(SHOWN_KEY, '1', true);
      submitLocalization(country, pickLang(entry[2] || [], country));
      return;
    }

    // Země, kam neprodáváme: nabídku trhu neukazovat, uvítací okno ano.
    if (!welcomePending && (!country || !entry)) return;

    whenLoaded(function () {
      window.setTimeout(function () {
        afterConsent(function () {
          if (welcomePending) {
            showWelcome(country, entry);
            return;
          }
          decide(country, entry);
        });
      }, 1200);
    });
  });
})();
